export function stripEmpty(value) {
  if (Array.isArray(value)) {
    return value
      .map(item => stripEmpty(item))
      .filter(item => item !== undefined)
  }
  if (value && typeof value === 'object' && !(value instanceof File)) {
    const next = {}
    Object.keys(value).forEach(key => {
      if (key.charAt(0) === '_') return
      const cleaned = stripEmpty(value[key])
      if (cleaned === undefined || cleaned === '') return
      next[key] = cleaned
    })
    return next
  }
  if (value === undefined || value === null || value === '') return undefined
  return value
}

function appendValue(formData, key, value) {
  if (value === undefined || value === null || value === '') return
  if (typeof value === 'boolean') {
    formData.append(key, value ? '1' : '0')
    return
  }
  formData.append(key, value instanceof Blob ? value : String(value))
}

export function toFormData(body) {
  const formData = new FormData()
  appendValue(formData, 'input_type', body.input_type)
  appendValue(formData, 'mode', body.mode)
  appendValue(formData, 'source_system', body.source_system)
  appendValue(formData, 'utm_zone', body.utm_zone)
  appendValue(formData, 'radius_meters', body.radius_meters)
  appendValue(formData, 'include_nearby', body.include_nearby)
  appendValue(formData, 'per_layer_limit', body.per_layer_limit)
  appendValue(formData, 'year', body.year)
  if (body.file) formData.append('file', body.file);
  (body.sources || []).forEach(source => formData.append('sources[]', source));
  (body.layers || []).forEach(layer => formData.append('layers[]', layer))
  return formData
}
